import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';

import { CONSTANT_VALUES } from '../../constants/constant-values';
import { ISlimScrollOptions } from 'ng2-slimscroll';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { AppService } from '../../app.service';
import 'rxjs/add/operator/map';
import { MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { FeedbackService } from './../feedback.service';
import { UISETTING } from './../../shared/ui-setting';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'app-feedback-list',
    templateUrl: './feedback-list.component.html',
    styleUrls: ['./feedback-list.component.css'],
    providers: [MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, FeedbackService, HiddenFooter, SetAllMemberCheck]
})
export class FeedbackListComponent implements OnInit {
    public appCall: any;
    private _router;
    private shouldSlide: boolean = false;
    private fieldlist = 80;
    private popUpMessage: any;
    private vendor;
    private feedbackData = [];
    private message = '';
    private noFeedbackText = true;
    private clubName = '';
    private messageForNoFeed = '';
    private selectedCriteria = 'Feedback';
    private feedbackTypeList = ['Feedback', 'Enquiry'];
    private statusCriteria = '';
    private exp = false;
    private search = '';
    private activityList = [];
    private setFilter = [];
    private setFilterSet = [];
    private scrollOptions: ISlimScrollOptions;
    private popupScrollOptions: ISlimScrollOptions;
    private filterCategory = '';
    private filter = {
        category: '',
        list: []
    };
    private selectAll;
    private feedBackDataForFilter = [];
    private uiSetting: UISETTING;
    private feedbackStatusEnum = [
      {status:'Open',selected:''},
      {status:'Close',selected:''}
    ]
    private height: any;
    private utilityFunctions = new UtilityFunctions();
    constructor(private router: Router, private appService: AppService,
        private messageEvent: MessageEvent, private signInEvent: SignInEvent,
        private loaderEvent: LoaderEvent, private facilityListEvent: FacilityListEvent, private openFrameEvent: OpenFrameEvent,
        private feedbackService: FeedbackService, private hiddenFooter: HiddenFooter, private setAllMemberCheck: SetAllMemberCheck) {
        this.uiSetting = {
            'windowHeight': window.innerHeight,
            'topNav': 56,
            'midNav': 45,
            'footer': 35,
            'container': 40
        };
        this.scrollOptions = {
            barBackground: "#343a40", barOpacity: "0.6", position: "right",
            barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
        };
        this.popupScrollOptions = {
            barBackground: "#343a40", barOpacity: "0.6", position: "right",
            barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
        }
        this._router = router;
        this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer + this.fieldlist)) + 'px';
        this.messageForNoFeed = CONSTANT_MESSAGES.MESSAGE_NO_FEEDBACK_ADDED;
    }

    ngOnInit() {
        this.emitOpenFrameEvent();
        window.scrollTo(0, 0);
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
            if (this.vendor.subVendors.length > 0) {
                let subVendor = this.vendor.subVendors[0];
                this.clubName = subVendor.clubName;
            }
        } else {
            this.clubName = this.vendor.clubName;
        }
        this.getFeedbackByVendor('Feedback');
        this.getActivityList();

        this.registerTypeBroadcast();
        this.emitTypeBroadcast();
    }

    /**
     * while menu slide left to right as well as we shift header, footer and body too like menu by broadcaster
     */

    registerTypeBroadcast() {
        this.messageEvent.on()
            .subscribe(message => {
                this.shouldSlide = message;
            });
    }

    /**
     * logout function to clear session and redirect to sign in page
     */

    logout() {
        this.appService.logout();
        this._router.navigate(['/']);
    }

    /**
     * function show menu at facility page by broadcaster
     */

    emitTypeBroadcast() {
        let isShow = {
            privacypolicy: true,
            support: false,
            footer: 'block'
        };
        this.signInEvent.fire('block');
        this.hiddenFooter.fire(isShow);
    }
    emitTypeLoaderBroadcast() {
        this.loaderEvent.fire(false);
    }

    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }

    /**
     * Redirecting to member page
     */

    homeScreen() {
        this.utilityFunctions.homeScreen(this);
    }

    getFeedbackByVendor(selectedCriteria) {
        try {
            let that = this;
            let feedbackObj = {
                vendorId: this.vendor._id,
                perPage: 1000,
                pageNumber: 1,
                'filters': [
                    {
                        "type": "contactus",
                        "values": selectedCriteria == 'Feedback' ? false : true
                    }
                ]
            };
            this.loaderEvent.fire(false);
            this.feedbackService.getFeedbackByVendor(feedbackObj).then((result: any) => {
                if (result.status === 'SUCCESS') {
                    if (result.data.length > 0) {
                        this.feedbackData = result.data;
                        this.feedbackData.map(function (rec: any) {
                            rec.eventdate = that.utilityFunctions.maketimeZoneOfsetDate(rec['createdAt']) ? that.utilityFunctions.maketimeZoneOfsetDate(rec['createdAt']).format('dddd, MMM DD, YYYY') : '';
                            if (rec['activity'] === 'Contact Us' && !rec.attachments[0]) {
                                rec.attachments.push('../../../assets/images/Contactus_placeholder.png');
                                rec.default = true;
                            } else if (!rec.attachments[0]) {
                                rec.attachments.push('../../../assets/images/placeholder.png');
                                rec.default = true
                            } else {
                            }
                            return rec;
                        });
                        this.noFeedbackText = true;
                        this.feedBackDataForFilter = this.feedbackData;
                    } else {
                        this.message = CONSTANT_MESSAGES.MESSAGE_NO_FEEDBACK_ADDED;
                        this.noFeedbackText = false;
                    }
                    this.loaderEvent.fire(true);
                } else {
                    this.loaderEvent.fire(true);
                }
            });
        } catch (err) {
            console.log(err);
        }
    }
    /**
     *
     *
     * @param {any} str
     * @param {any} find
     * @param {any} replace
     * @returns
     *
     * @memberof FeedbackListComponent
     */
    replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
    }
    /**
     * Open feedback reply popup
     *
     * @param {any} item
     * @param {any} popup
     *
     * @memberof FeedbackListComponent
     */
    showReplyPopup(item, popup) {
        popup.showChildModal(item);
    }
    /**
     * Open feedback forward popup
     *
     * @param {any} item
     * @param {any} popup
     *
     * @memberof FeedbackListComponent
     */
    showForwardPopup(item, popup) {
        popup.showChildModal(item);
    }

    actionOnCriteria(selectedPara, popupObj) {
        this.noFeedbackText = false;
        this.selectedCriteria = selectedPara;
    }

    expand() {
        this.exp = !this.exp;
    }
    /**
     * Get activity list in condo
     *
     *
     * @memberof FeedbackListComponent
     */
    getActivityList() {
        let vendorObj = {
            vendorId: this.vendor._id
        };
        this.loaderEvent.fire(false);
        this.appService.getActivityListByVendor(vendorObj).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.activityList = result.data;
                this.activityList.map(function (rec: any) {
                    rec.openSubMenuClass = 'strrev';
                    rec.selectedItem = '';
                    return rec;
                });

            } else {
            }
            this.loaderEvent.fire(true);
        });
    }
    /**
     * Un select other category in filter
     *
     * @param {any} categoryName
     *
     * @memberof FeedbackListComponent
     */
    makeOtherUnselect(categoryName) {
        this.selectAll = '';
        this.setFilter = [];
        this.filterCategory = categoryName;
        let that = this;
        this.activityList = this.activityList.map(function (rec: any) {
            if (rec.activity !== categoryName) {
                rec.openSubMenuClass = 'strrev';
                rec.selectedItem = '';
                rec.subActivities.map(function (item: any) {
                    item.isChecked = false;
                    return item;
                });
            } else if (that.filter.category == categoryName) {
                rec.openSubMenuClass = 'str';
                rec.selectedItem = 'selectfilternav';
                rec.subActivities.map(function (item: any) {
                    if (that.filter.list.indexOf(item.id) >= 0) {
                        item.isChecked = true;
                        that.setFilter.push(item.id);
                    } else {
                        item.isChecked = false;
                    }
                    return item;
                });
            } else {
                rec.openSubMenuClass = 'str';
                rec.selectedItem = 'selectfilternav';
            }
            return rec;
        });
    }
    /**
     * Set filter to apply
     *
     * @param {any} activity
     * @param {any} event
     *
     * @memberof FeedbackListComponent
     */
    setFilterArray(activity, event) {
        this.feedbackStatusEnum.forEach(feed => {
          feed.selected = '';
        })
        if (event.target.checked) {
            this.setFilter.push(activity.id);
            activity.selected = ''
        } else if( activity.status === 'Open'){
          activity.selected = 'selectfilternav';
          this.statusCriteria = activity.status;
          this.selectAll = ''
        } else if( activity.status === 'Close'){
          activity.selected = 'selectfilternav';
          this.statusCriteria = activity.status;
          this.selectAll = ''
        } else {
          activity.selected = ''
            _.remove(this.setFilter, function (n) {
                return n === activity.id;
            });
        }

        this.setFilter = _.uniq(this.setFilter);
    }
    /**
     * Apply filter
     *
     *
     * @memberof FeedbackListComponent
     */
    applyFilter() {
        if (this.selectAll == 'selectfilternav') {
            this.getFeedbackByVendor('Feedback');
            this.filter.category = '';
            this.filter.list = [];
        } else if (this.setFilter.length != 0) {
            this.filter.category = this.filterCategory;
            this.filter.list = this.setFilter;
            let that = this;
            let feedbackDataList = this.feedBackDataForFilter;
            this.feedbackData = feedbackDataList.filter(function (rec: any) {
                if (that.filter.list.indexOf(rec.facilityId) >= 0) {
                    return rec;
                }
            });
            if (this.feedbackData.length == 0) {
                this.noFeedbackText = false;
            } else {
                this.noFeedbackText = true;
            }
        } else if(this.statusCriteria == 'Open'){
          let feedbackDataList = this.feedBackDataForFilter;
          this.feedbackData = feedbackDataList.filter((rec: any) => {
              if (rec.isOpen === true) {
                  return rec;
              }
          });
        } else if(this.statusCriteria === 'Close'){
          let feedbackDataList = this.feedBackDataForFilter;
          this.feedbackData = feedbackDataList.filter((rec: any) => {
              if (rec.isOpen === false) {
                  return rec;
              }
          });
        } else {
            this.getFeedbackData('Feedback');
        }
    }
    /**
     * Maintain applied filter
     *
     *
     * @memberof FeedbackListComponent
     */
    maintainState() {
        if (this.selectAll != 'selectfilternav') {
            this.filterCategory = this.filter.category;
            this.setFilter = this.filter.list;
            let that = this;
            this.activityList = this.activityList.filter(function (rec: any) {
                if (rec.activity !== that.filter.category) {
                    rec.openSubMenuClass = '';
                    rec.selectedItem = '';
                } else {
                    rec.openSubMenuClass = '';
                    rec.selectedItem = 'selectfilternav';
                    rec.subActivities.map(function (item: any) {
                        if (that.filter.list.indexOf(item.id) >= 0) {
                            item.isChecked = true;
                        } else {
                            item.isChecked = false;
                        }
                        return item;
                    });
                }
                return rec;
            });
        }
    }
    /**
     * Set filter to ALL category
     *
     *
     * @memberof FeedbackListComponent
     */
    allSelectAction() {
        this.feedbackStatusEnum.forEach(feed => {
          feed.selected = '';
        })
        this.selectAll = 'selectfilternav';
        this.setFilter = [];
        this.filterCategory = '';
        this.activityList = this.activityList.map(function (rec: any) {
            rec.openSubMenuClass = 'strrev';
            rec.selectedItem = '';
            rec.subActivities.map(function (item: any) {
                item.isChecked = false;
                return item;
            });
            return rec;
        });
    }
    /**
     * Get feedback list
     *
     * @param {any} criteria
     *
     * @memberof FeedbackListComponent
     */
    getFeedbackData(criteria) {
        this.getFeedbackByVendor(criteria);
        let that = this;
        this.activityList = this.activityList.filter(function (rec: any) {
            rec.openSubMenuClass = '';
            rec.selectedItem = '';
            rec.subActivities.map(function (item: any) {
                item.isChecked = false;
                return item;
            });
            return rec;
        });
        this.filter.category = '';
        this.filter.list = [];
    }

    switchStatus(event,item){
      item['isOpen'] = event;
      item['feedbackId'] = item._id;
      this.feedbackService.updateFeedback(item).then(result => {
        console.log(result);
      })

    }
}



// WEBPACK FOOTER //
// ./src/app/feedback/feedback-list/feedback-list.component.ts